import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EMenuButtonItemType, IMenuButtonProperties } from '../../../store/models/menu-button.model';
import { IUserSessionData, UserType } from '../../../store/models/user.model';

@Component({
  selector: 'app-associated-products-mobile-row',
  templateUrl: './associated-products-mobile-row.component.html',
  styleUrls: ['./associated-products-mobile-row.component.scss'],
})
export class AssociatedProductsMobileRowComponent implements OnInit {
  @Input() item: any;
  @Input() currentUser: IUserSessionData;

  @Output() update: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();

  menuItems: IMenuButtonProperties = {
    items: [],
  };

  constructor() {
  }

  ngOnInit(): void {
    if (
      this.currentUser &&
      this.currentUser.user_type !== UserType.PARTNER &&
      this.currentUser.user_type !== UserType.FRANCHISE
    ) {
      this.menuItems.items = [
        {
          label: 'Update',
          type: EMenuButtonItemType.BUTTON,
          onClick: target => this.update.emit(target),
        },
        {
          label: 'Delete',
          type: EMenuButtonItemType.BUTTON,
          onClick: target => this.delete.emit(target),
          class: 'alert-danger',
        },
      ];
    }
  }

}
